// hooks/usePlatform.js
import { useState, useEffect } from 'react';

export const usePlatform = () => {
    const [platform, setPlatform] = useState('web');
    const [isTelegram, setIsTelegram] = useState(false);
    const [telegramUser, setTelegramUser] = useState(null);
    const [isWeb, setIsWeb] = useState(true);
    const API_URL = window.location.origin;

    async function getInternalIdByTelegramId(telegramId) {
        try {
            const response = await fetch(`${API_URL}/api/user/get-internal-id/${telegramId}`);
            const data = await response.json();

            if (data.success) {
                console.log('Внутренний ID:', data.internalId);
                console.log('Данные пользователя:', data.user);
                return data.internalId;
            } else {
                console.error('Ошибка:', data.error);
                return null;
            }
        } catch (error) {
            console.error('Ошибка запроса:', error);
            return null;
        }
    }

    useEffect(() => {
        // Проверяем, запущено ли в Telegram WebApp
        const webApp = window.Telegram?.WebApp;
        const user = webApp?.initDataUnsafe?.user;

        // Главный признак — наличие пользователя в initDataUnsafe
        if (user && user.id) {
            setIsTelegram(true);
            setIsWeb(false);
            setTelegramUser(user);

            // Определяем платформу
            const tgPlatform = webApp.platform || 'web';
            let mappedPlatform = 'android';

            if (tgPlatform === 'ios') {
                mappedPlatform = 'ios';
            } else if (tgPlatform === 'android') {
                mappedPlatform = 'android';
            } else if (tgPlatform === 'windows' || tgPlatform === 'tdesktop') {
                mappedPlatform = 'windows';
            } else if (tgPlatform === 'macos') {
                mappedPlatform = 'macos';
            } else {
                // Для веб-версии определяем по userAgent
                const userAgent = navigator.userAgent.toLowerCase();
                if (userAgent.includes('mac')) {
                    mappedPlatform = 'macos';
                } else if (userAgent.includes('win')) {
                    mappedPlatform = 'windows';
                } else if (userAgent.includes('android')) {
                    mappedPlatform = 'android';
                } else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
                    mappedPlatform = 'ios';
                }
            }

            setPlatform(mappedPlatform);
            console.log('🔍 [Telegram] Платформа:', mappedPlatform, 'Пользователь:', user.id);
        } else {
            // Обычный браузер
            setIsTelegram(false);
            setIsWeb(true);
            setTelegramUser(null);

            // Определяем платформу по userAgent
            const userAgent = navigator.userAgent.toLowerCase();
            let mappedPlatform = 'windows';

            if (userAgent.includes('mac')) {
                mappedPlatform = 'macos';
            } else if (userAgent.includes('android')) {
                mappedPlatform = 'android';
            } else if (userAgent.includes('win')) {
                mappedPlatform = 'windows';
            } else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
                mappedPlatform = 'ios';
            }

            setPlatform(mappedPlatform);
            console.log('🔍 [Web] Платформа:', mappedPlatform);
        }
    }, []);

    return { platform, isTelegram, telegramUser, isWeb };
};